module.exports = __webpack_public_path__ + "static/media/excel.327c7ded.png";